import { theme as coinspaidTheme } from './storage/coinspaid'

const themes = {
  coinspaid: coinspaidTheme,
}

export const themeList = Object.keys(themes)

export const getTheme = (theme) => themes[theme] || (() => new Error(`Theme ${theme} not found!`))
